import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { useCallback } from 'react';
import { SEND_MESSAGE_USE_CASE } from '../../../../../ai';
import { getUseCase } from '@lib/plugin-redux-core';
import { useDispatch, useSelector } from 'react-redux';
import { selectSendMessageOutput, selectAttachments } from '../../../redux/ai-chat/ai-chat.selectors';
import { message } from 'antd';
import { isFileExtensionAllowed, isFileSizeWithinLimit, isTotalFileSizeWithinLimit } from '../../../../../file-management-app';
export var useUserSendMessage = function useUserSendMessage(_ref) {
  var conversationId = _ref.conversationId,
      onBuildingDataBeforeSendMessage = _ref.onBuildingDataBeforeSendMessage,
      streamCallbacks = _ref.streamCallbacks,
      onSnapshotMentionResources = _ref.onSnapshotMentionResources,
      llmConfig = _ref.llmConfig,
      extraFiles = _ref.extraFiles,
      fileRules = _ref.fileRules;
  var dispatch = useDispatch();
  var sendMessageUseCase = getUseCase(SEND_MESSAGE_USE_CASE, dispatch);
  var sendMessageOutput = useSelector(selectSendMessageOutput);
  var attachments = useSelector(selectAttachments);
  var sendMessage = useCallback(function (content) {
    var _attachments$map, _fileRules$totalSizeL, _attachments$map2, _extraFiles$map;

    if (!conversationId) return false;

    if (attachments !== null && attachments !== void 0 && attachments.length && (!fileRules || fileRules.fileSizeLimit <= 0 || fileRules.totalSizeLimit <= 0)) {
      message.error('File limits are unavailable for the selected model. Remove attachments or choose another model.');
      return false;
    }

    var invalidAttachment = attachments === null || attachments === void 0 ? void 0 : attachments.find(function (attachment) {
      var _fileRules$allowedFil, _fileRules$fileSizeLi;

      return !isFileExtensionAllowed(attachment.name, (_fileRules$allowedFil = fileRules === null || fileRules === void 0 ? void 0 : fileRules.allowedFileExtensions) !== null && _fileRules$allowedFil !== void 0 ? _fileRules$allowedFil : []) || !isFileSizeWithinLimit(attachment.size, (_fileRules$fileSizeLi = fileRules === null || fileRules === void 0 ? void 0 : fileRules.fileSizeLimit) !== null && _fileRules$fileSizeLi !== void 0 ? _fileRules$fileSizeLi : 0);
    });

    if (invalidAttachment) {
      message.error("\"".concat(invalidAttachment.name, "\" is not supported by the selected model or exceeds its file limit."));
      return false;
    }

    if (!isTotalFileSizeWithinLimit((_attachments$map = attachments === null || attachments === void 0 ? void 0 : attachments.map(function (attachment) {
      return attachment.size;
    })) !== null && _attachments$map !== void 0 ? _attachments$map : [], (_fileRules$totalSizeL = fileRules === null || fileRules === void 0 ? void 0 : fileRules.totalSizeLimit) !== null && _fileRules$totalSizeL !== void 0 ? _fileRules$totalSizeL : 0)) {
      message.error('The combined size of files exceeds the selected model limit.');
      return false;
    } // Clean up previous subscription


    if (sendMessageOutput) {
      sendMessageOutput.unsubscribe();
    }

    var data;

    if (onBuildingDataBeforeSendMessage) {
      data = onBuildingDataBeforeSendMessage();
    }

    var internalIds = (_attachments$map2 = attachments === null || attachments === void 0 ? void 0 : attachments.map(function (attachment) {
      return attachment.id;
    })) !== null && _attachments$map2 !== void 0 ? _attachments$map2 : [];
    var extraIds = (_extraFiles$map = extraFiles === null || extraFiles === void 0 ? void 0 : extraFiles.map(function (file) {
      return file.id;
    })) !== null && _extraFiles$map !== void 0 ? _extraFiles$map : [];
    var mergedFileIds = Array.from(new Set([].concat(_toConsumableArray(internalIds), _toConsumableArray(extraIds))));
    var formReferenceResources = (extraFiles !== null && extraFiles !== void 0 ? extraFiles : []).map(function (file) {
      return {
        resourceType: 'form',
        resourceId: file.id
      };
    });
    var payload = {
      conversationId: conversationId,
      content: content,
      data: data,
      fileIds: mergedFileIds.length > 0 ? mergedFileIds : undefined,
      resources: formReferenceResources.length > 0 ? formReferenceResources : undefined,
      callbacks: streamCallbacks,
      llmConfig: llmConfig
    };
    sendMessageUseCase.execute(payload);

    if (onSnapshotMentionResources) {
      onSnapshotMentionResources();
    }

    return true;
  }, [conversationId, sendMessageOutput, onBuildingDataBeforeSendMessage, onSnapshotMentionResources, attachments, extraFiles, sendMessageUseCase, streamCallbacks, llmConfig, fileRules]);
  return {
    sendMessage: sendMessage
  };
};